module.exports = __webpack_public_path__ + "img/classroom_icon.574e5534.png";